import {html, type TemplateResult} from "lit";
import {queryAll, state} from "lit/decorators.js";
import {UnLitElement} from "../../common/elements";
import {EopDialog} from "../../page/elements/dialog/dialog";

export abstract class RenderedDialogContent {

    protected constructor(
        public readonly dialogId: string
    ) {
    }
}

export abstract class RenderedDialogs<T extends RenderedDialogContent> extends UnLitElement {

    @queryAll("eop-dialog")
    private dialogs: NodeListOf<EopDialog>;

    @state()
    protected dialogContents: T[] = [];

    protected abstract readonly dialogClass: string;

    public render(): TemplateResult[] {
        return this.dialogContents.map(dialog => html`
            <eop-dialog id=${dialog.dialogId} class=${this.dialogClass}
                        content-slot-name="dialog-content" popovers-slot-name="dialog-popovers">
                <div eop-slot="dialog-content" class="dialog-content">
                    ${this.renderDialogContent(dialog)}
                </div>
            </eop-dialog>
        `);
    }

    protected abstract renderDialogContent(dialog: T): TemplateResult;

    public open(dialogId: string): void {
        const dialog = Array.from(this.dialogs).find(d => d.id === dialogId);
        if (dialog) {
            dialog.showModal();
        }
    }

    public removeDialog(dialogId: string): void {
        this.dialogContents = this.dialogContents.filter(dialog => dialog.dialogId !== dialogId);
    }
}
